import type { Contract } from '../types/types'

export const countApprovedSchemaCombinations = (
  contracts: Contract[],
  payloadSchemaId: number
): number =>
  contracts.reduce((count, contract) => {
    const affected = (contract.analysisTypes ?? []).filter(
      (item) =>
        item.analysisType?.payloadSchema?.id === payloadSchemaId &&
        item.labApproval === true
    )
    return count + affected.length
  }, 0)

export const countSchemaCombinations = (
  contracts: Contract[],
  payloadSchemaId: number
): number =>
  contracts.reduce((count, contract) => {
    const affected = (contract.analysisTypes ?? []).filter(
      (item) => item.analysisType?.payloadSchema?.id === payloadSchemaId
    )
    return count + affected.length
  }, 0)
